import FreshLeaksRoutes from "./FreshLeaks.routes";
import { post, get, put, deleted } from "../../index";

const FreshLeaksServices = {
  createFreshLeak: async (obj) => {
    const result = await post(FreshLeaksRoutes.createFreshLeak, obj);
    return result;
  },

  getAllFreshLeaks: async (page, limit) => {
    const result = await get(FreshLeaksRoutes.getAllFreshLeaks + `?page=${page}&limit=${limit}`);
    return result;
  },

  updateFreshLeak: async (id, obj) => {
    const result = await put(FreshLeaksRoutes.updateFreshLeak + `/${id}`, obj);
    return result;
  },

  deleteFreshLeak: async (id) => {
    const result = await deleted(FreshLeaksRoutes.deleteFreshLeak + `/${id}`);
    return result;
  },
}

export default FreshLeaksServices;